<app-info-modal title="Ofertas Customizadas">
    <div
        class="eu-display_flex eu-justify_center eu-align-items_center pricing-modal-body"
        style="min-height: 4rem"
    >
        <div style="min-height: 1rem">
            <p class="emd-text _size_section _color_default">
                Esta funcionalidade consiste em disponibilizar Ofertas pre aprovadas no ato do
                credenciamento.
            </p>
        </div>
    </div>
</app-info-modal>
